export class AccountModuleVersion {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "module",
            "baseName": "module",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "installed",
            "baseName": "installed",
            "type": "string",
            "format": ""
        },
        {
            "name": "installationMethod",
            "baseName": "installationMethod",
            "type": "AccountInstallationMethod",
            "format": ""
        },
        {
            "name": "latest",
            "baseName": "latest",
            "type": "string",
            "format": ""
        },
        {
            "name": "needsUpdate",
            "baseName": "needsUpdate",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AccountModuleVersion.attributeTypeMap;
    }
    constructor() {
    }
}
